import { Report } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { providerRefs, siteRefs, userRefs } from '../../factories/seeds/entities';
import { mockProviders } from './providerMock';
import { mockSites } from './siteMock';
import { mockUsers } from './userMock';

const providerByID = new Map(
  mockProviders.map((provider) => [provider.id, provider])
);
const siteByID = new Map(mockSites.map((site) => [site.id, site]));
const userByID = new Map(mockUsers.map((user) => [user.id, user]));

const reportSite = siteByID.get(siteRefs.qdocVirtualHealthcare.id) ?? null;
const reportProvider = providerByID.get(providerRefs.weezerRockMusic.id) ?? null;
const reportUser = userByID.get(userRefs.adamLowryUser.id) ?? null;

export const mockReports: Report[] = [
  {
    id: 'e96a2886-8e25-42bb-8f9f-b662f45dc571',
    type: 'providerIncome',
    s3Path: `income/provider/${reportProvider?.id ?? ''}/income-report-1743523414459.pdf`,
    siteID: reportSite?.id ?? '',
    createdAt: '2025-04-01T21:03:45.572Z',
    cognitoID: '5c9d35f8-c061-7065-5652-a9066bed47cd',
    userID: reportUser?.id ?? '',
    status: 'created',
    providerID: reportProvider?.id ?? '',
  },
  {
    id: '5500ab05-afe8-4ae8-9f79-e6fa4538e733',
    type: 'providerIncome',
    s3Path: `income/provider/${reportProvider?.id ?? ''}/income-report-1743532856548.pdf`,
    siteID: reportSite?.id ?? '',
    createdAt: '2025-04-01T23:41:07.783Z',
    cognitoID: '5c9d35f8-c061-7065-5652-a9066bed47cd',
    userID: reportUser?.id ?? '',
    status: 'created',
  },
];

export const reportMockHandlers = [
  // mock for useListReports()
  http.get('*/resource/report/all', () => {
    return HttpResponse.json(mockReports);
  }),
  // useListReportsByProvider
  http.get('*/resource/report/provider', ({ request }) => {
    const url = new URL(request.url);
    const providerID = url.searchParams.get('providerID');
    const reports = mockReports.filter(
      (report) => !!providerID && report.providerID === providerID
    );
    return HttpResponse.json(reports);
  }),
  // useListReportsBySite
  http.get('*/resource/report/site', ({ request }) => {
    const url = new URL(request.url);
    const siteID = url.searchParams.get('siteID');
    const page = Number(url.searchParams.get('page') ?? 0);
    const pageSize = Number(url.searchParams.get('pageSize') ?? 1000);
    const reports = mockReports.filter((report) => report.siteID === siteID);
    const offset = page * pageSize;
    const data = reports.slice(offset, offset + pageSize);
    const pages = Math.ceil(reports.length / pageSize) || 1;
    const nextPage = Math.min(page + 1, pages);
    return HttpResponse.json({
      data,
      total: reports.length,
      pages,
      limit: pageSize,
      page,
      nextPage,
    });
  }),
  // useListReportsByUser
  http.get('*/resource/report/user', ({ request }) => {
    const url = new URL(request.url);
    const userID = url.searchParams.get('userID');
    const page = Number(url.searchParams.get('page') ?? 0);
    const pageSize = Number(url.searchParams.get('pageSize') ?? 10);
    const reports = mockReports.filter((report) => report.userID === userID);
    const offset = page * pageSize;
    const data = reports.slice(offset, offset + pageSize);
    const pages = Math.ceil(reports.length / pageSize) || 1;
    const nextPage = Math.min(page + 1, pages);
    return HttpResponse.json({
      data,
      total: reports.length,
      pages,
      limit: pageSize,
      page,
      nextPage,
    });
  }),

  http.post('*/resource/report', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.put('*/resource/report', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.post('*/action/generate/report/site', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
];

export const testReport: Report = {
  id: '1',
  type: 'test',
  s3Path: 'test',
  userID: reportUser?.id ?? '',
  siteID: reportSite?.id ?? '',
  createdAt: 'test',
  cognitoID: 'test',
  endDate: 'test',
  startDate: 'test',
  status: 'test',
};
